import { BaseModel, convertToArrayModels, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import ResearchShowcaseFilter from './ResearchShowcaseFilter'

export default class ResearchShowcaseFilters extends BaseModel {
  static override constructorName = 'ResearchShowcaseFilters'

  list: ResearchShowcaseFilter[] = []

  constructor(data?: unknown) {
    super(data)

    let rawFilters: unknown = []

    if (Array.isArray(data)) {
      rawFilters = data
    }
    else if (isUnknownObject(data) && Array.isArray(data.data)) {
      rawFilters = data.data
    }

    this.list = convertToArrayModels(rawFilters, ResearchShowcaseFilter)
  }
}

registerModel(ResearchShowcaseFilters)
